(() => {
  const form = document.getElementById('EventInquiry');
  if (!form) return;
  const topics = {rental:'Rental',purchase:'In-store purchase',deciding:'Help deciding'};
  const occasions = {wedding:'Wedding',gala:'Gala or black tie',holiday:'Holiday or New Year celebration',prom:'Prom or school formal',performance:'Performance'};
  const params = new URLSearchParams(location.search);
  const setChoice = (name, value) => {
    const field = form.elements.namedItem(name);
    if (field && !field.value && value && [...field.options].some(option => option.value === value)) field.value = value;
  };
  setChoice('contact[request_type]', topics[params.get('intent')]);
  setChoice('contact[occasion]', occasions[params.get('occasion')]);
  const container = form.querySelector('[data-event-look]');
  if (!container) return;
  const include = form.querySelector('[data-event-include-look]');
  const preview = form.querySelector('[data-event-look-preview]');
  const field = form.querySelector('[data-event-look-value]');
  const refresh = () => {
    let state = {items:[]};
    try { state = window.BoiseLook?.read() || state; } catch (_) {}
    const items = Array.isArray(state.items) ? state.items.slice(0,20) : [];
    const text = items.map(item => [item.name || item.title || item.item || '',item.color || ''].filter(Boolean).map(value => String(value).slice(0,200)).join(' — ')).filter(Boolean).join('\n');
    container.hidden = !text;
    if (!text) include.checked = false;
    preview.textContent = text;
    preview.hidden = !include.checked;
    field.disabled = !include.checked || !text;
    field.value = field.disabled ? '' : (state.mode === 'buy' ? 'In-store purchase plan' : 'Rental style plan') + '\n' + text;
  };
  include.addEventListener('change',refresh);
  window.addEventListener('boise-look-changed',refresh);
  form.addEventListener('submit',refresh);
  refresh();
})();
